import * as React from "react";
import "./style.scss";
export default function SplitLinkContainer ({children,className}) {
    return <section className={` link-container ${className} `}>{children}</section>
}